import React from 'react';
import map from 'lodash/map';
import PropTypes from 'prop-types';

const propTypes = {
  title: PropTypes.any,
  dataArray: PropTypes.array.isRequired,
  skillTr: PropTypes.func.isRequired,
};

const defaultProps = {
  title: null,
  dataArray: [],
  skillTr: () => {
  },
};

const CategoryProfileList = ({ title, dataArray, skillTr }) => {
  return (
    <div className="card">
      <div className="card-header">{title}</div>
      <div className="card-body">
        <table className="table table-bordered" width="100%" cellSpacing="0">
          <tbody>
          {
            map(dataArray, (item, key) =>
              <tr key={'skill_' + key}>
                <td>{skillTr(item)}</td>
              </tr>
            )
          }
          </tbody>
        </table>
      </div>
    </div>
  );
};

CategoryProfileList.propTypes = propTypes;
CategoryProfileList.defaultProps = defaultProps;
export default CategoryProfileList;



// WEBPACK FOOTER //
// ./src/components/CategoryProfileList/index.jsx